import { AuthAction, AuthActionTypes } from '../actions/authActions'

export interface User {
  id: string
  username: string
  email?: string
  firstName?: string
  lastName?: string
  companyName?: string
  contactNumber?: string
  workingDir: string
  plan?: string
  subscribed?: 'F' | 'P' | 'S' // F=Free, P=Pending payment, S=Subscribed
  role?: 'user' | 'admin'
  mfaEnabled?: boolean
  authProvider?: string
}

export interface AuthState {
  user: User | null
  token: string | null
  isAuthenticated: boolean
  isLoading: boolean
  error: string | null
  signupSuccess: boolean
  emailVerified: boolean
}

const initialState: AuthState = {
  user: null,
  token: localStorage.getItem('token'),
  isAuthenticated: false,
  isLoading: !!localStorage.getItem('token'),
  error: null,
  signupSuccess: false,
  emailVerified: false,
}

const authReducer = (state = initialState, action: AuthAction): AuthState => {
  switch (action.type) {
    case AuthActionTypes.SIGNUP_REQUEST:
    case AuthActionTypes.VERIFY_EMAIL_REQUEST:
    case AuthActionTypes.LOGIN_REQUEST:
    case AuthActionTypes.CHECK_AUTH_REQUEST:
    case AuthActionTypes.LOGOUT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      }

    case AuthActionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        user: action.payload.user,
        token: action.payload.token,
        isAuthenticated: true,
        error: null,
      }

    case AuthActionTypes.CHECK_AUTH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        user: action.payload.user,
        isAuthenticated: true,
        error: null,
      }

    case AuthActionTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        user: null,
        token: null,
        isAuthenticated: false,
        error: null,
      }

    case AuthActionTypes.SIGNUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        signupSuccess: true,
        error: null,
      }

    case AuthActionTypes.VERIFY_EMAIL_SUCCESS:
      localStorage.setItem('token', action.payload.token)
      return {
        ...state,
        isLoading: false,
        emailVerified: true,
        user: action.payload.user,
        token: action.payload.token,
        isAuthenticated: true,
        error: null,
      }

    case AuthActionTypes.SIGNUP_FAILURE:
    case AuthActionTypes.VERIFY_EMAIL_FAILURE:
    case AuthActionTypes.LOGIN_FAILURE:
    case AuthActionTypes.CHECK_AUTH_FAILURE:
    case AuthActionTypes.LOGOUT_FAILURE:
      return {
        ...state,
        isLoading: false,
        user: null,
        token: null,
        isAuthenticated: false,
        error: action.payload,
      }

    case AuthActionTypes.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      }

    case AuthActionTypes.SET_CREDENTIALS:
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        isAuthenticated: true,
        error: null,
      }

    case AuthActionTypes.UPDATE_USER:
      return {
        ...state,
        user: action.payload.user ? {
          ...state.user,
          ...action.payload.user,
          plan: action.payload.user.subscribed === 'S' ? 'pro' : 'free'
        } : state.user,
      }

    default:
      return state
  }
}

export default authReducer